export const NAVBAR_BLOCK_s4 = {
  "blockType": "NAVBAR",
  "blockDesign": "NavDesign1",
  "editFormName": "NAVBAR_FORM_1",
  "styleProps": {
    "background-color": "#ffffff"
  },
  "logoType": "text",
  "logoImg": {
    "src": "https://freshflowxyz.b-cdn.net/assets/logo/FlexBee-Logo-1.jpg",
    "altText": "FlexBee",
    "styleProps": {
      "height": "3rem"
    }
  },
  "logoText": {
    "text": "Nodic",
    "styleProps": {
      "font-size": "1.25rem",
      "color": "#333333",
      "font-family": "'Lato', sans-serif",
      "line-height": "1.75rem",
      "font-family-bk": "'Lato', sans-serif",
      "font-weight": "900"
    },
    "stylePropsMob": {},
    "stylePropsTab": {}
  },
  "logoHTML": {
    "html": "FlexBee",
    "styleProps": {
      "font-size": "1.875rem",
      "color": "#ffffff",
      "font-family": "'Oswald', sans-serif",
      "line-height": "2.25rem"
    },
    "stylePropsMob": {},
    "stylePropsTab": {}
  },
  "links": [
    {
      "text": "FEATURES",
      "linkUrl": "/features",
      "styleProps": {
        "color": "",
        "padding": "6px 20px 6px 20px"
      },
      "sectionID": "aboutsection"
    },
    {
      "text": "SERVICES",
      "linkUrl": "/services",
      "styleProps": {
        "color": "",
        "padding": "6px 20px 6px 20px"
      },
      "sectionID": "aboutsection"
    },
    {
      "text": "DOCS",
      "linkUrl": "/docs",
      "styleProps": {
        "color": "",
        "padding": "6px 20px 6px 20px"
      },
      "sectionID": "aboutsection"
    }
  ],
  "hamburgerStyleProps": {
    "color": "#333333",
    "border-color": "#333333"
  },
  "metaDataId": 1746277895787,
  "afterIndex": 4,
  "blockId": 1746277895787,
  "linksStyleProps": {
    "color": "#333333",
    "padding": "2px 0px 2px 0px",
    "font-weight": "600",
    "font-size": "1rem",
    "line-height": "1.5rem"
  }
}